import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import { CMSProvider } from "./lib/cms";
import { WishlistProvider } from "./lib/wishlist";
import { CartProvider } from "./lib/cart";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import VinylDetail from "./pages/VinylDetail";
import Newsletter from "./pages/Newsletter";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Favoritos from "./pages/Favoritos";
import GenrePage from "./pages/GenrePage";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Shipping from "./pages/Shipping";
import SellRecords from "./pages/SellRecords";
import { ArticleList, ArticleDetail } from "./pages/Articles";
import ScrollToTop from "./components/ScrollToTop";
import "@/App.css";

function App() {
  return (
    <I18nProvider>
      <CMSProvider>
        <WishlistProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalogo" element={<Catalog />} />
                  <Route path="/catalogo/:slug" element={<VinylDetail />} />
                  <Route path="/generos/:style" element={<GenrePage />} />
                  <Route path="/favoritos" element={<Favoritos />} />
                  <Route path="/carrito" element={<Cart />} />
                  <Route path="/finalizar" element={<Checkout />} />
                  <Route path="/articulos" element={<ArticleList />} />
                  <Route path="/articulos/:slug" element={<ArticleDetail />} />
                  <Route path="/envios" element={<Shipping />} />
                  <Route path="/compramos-tus-discos" element={<SellRecords />} />
                  <Route path="/newsletter" element={<Newsletter />} />
                  <Route path="/sobre" element={<About />} />
                  <Route path="/contacto" element={<Contact />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="*" element={<Home />} />
                </Routes>
              </Layout>
              <Toaster position="bottom-right" richColors closeButton />
            </BrowserRouter>
          </CartProvider>
        </WishlistProvider>
      </CMSProvider>
    </I18nProvider>
  );
}

export default App;
